// Especialidades
import example from "../assets/Especialistas/perfil.png";
import JaimeDiazValdivia from "../assets/Especialistas/Dr. Jaime Díaz Valdivia.png";
import RicardoSahagunSanchez from "../assets/Especialistas/Dr. Ricardo Sahagún Sánchez.png";
import KristianJavierNavarreteBecerra from "../assets/Especialistas/Dr. Kristian Javier Navarrete Becerra.png";
import EnriqueIgnacioSolteroMartinez from "../assets/Especialistas/Dr. Enrique Ignacio Soltero Martínez.png";
import FranciscoJavierMunizCoronado from "../assets/Especialistas/Dr. Francisco Javier Muniz Coronado.png";
import JanetLizethVargasCortes from "../assets/Especialistas/Dra. Janet Lizeth Vargas Cortés.jpg";
import AlejandroSolano from "../assets/Especialistas/Dr. Alejandro Solano.png";
import GilbertodeJesusParraTorres from "../assets/Especialistas/Dr. Gilberto de Jesús Parra Torres.png";
import GilbertoMedinaFong from "../assets/Especialistas/Dr. Gilberto Medina Fong.png";
import LuisAntonioFloreRuvalcaba from "../assets/Especialistas/Dr. Luis Antonio Flores Ruvalcaba.png";
import HectorLeonardoTorresSoltero from "../assets/Especialistas/Dr. Héctor Leonardo Torres Soltero.png";
import AntonioDuranOrtega from "../assets/Especialistas/Dr. Antonio Durán Ortega.png";
import MarioGabrielGuevaraBarraza from "../assets/Especialistas/Dr. Mario Gabriel Guevara Barraza.jpg";
import RicardoSahagunTopete from "../assets/Especialistas/Dr. Ricardo Sahagun Topete.png";
import MariadelRocioZambranoCarrillo from "../assets/Especialistas/Dra. María del Rocío Zambrano Carrillo.png";
import JoseMiguelPlascenciaRamirez from "../assets/Especialistas/Dr. José Miguel Plascencia Ramírez.png"; 
import JosselineRodriguez from "../assets/Especialistas/Dra. Josseline Rodríguez.png";
import SilviaRodriguezJimenez from "../assets/Especialistas/Dra. Silvia Rodríguez Jiménez.png";
import MiguelLiceaPerezPeña from "../assets/Especialistas/Dr. Miguel Licea Pérez Peña.png";
import EvelynSeleneCortesSalvio from "../assets/Especialistas/Dra. Evelyn Selene Cortés Salvio.jpg";
import JesusRomeroRodriguez from "../assets/Especialistas/Dr. Jesús Alejandro Romero Rodríguez.jpg";
import JoseAlbertoGutierrezMata from "../assets/Especialistas/Dr. José Alberto Gutiérrez Mata.png";
import LuisErnestoHernandezRico from "../assets/Especialistas/Dr. Luis Ernesto Hernández Rico.png";
import JoseCarlosdelRealMartinez from "../assets/Especialistas/Dr. José Carlos del Real Martínez.png";
import JoseBenitodelRealMartinez from "../assets/Especialistas/Dr. José Benito del Real Martínez.png";
import ChristopherPeñaGeorge from "../assets/Especialistas/Dr. Christopher Peña George.png";

// Informacion Especialistas Medicos
import archivoDePrueba from "../assets/Especialistas/Informacion_Especialista/PATRONESCOLOR.pdf";

// Especialidades Categorias
export const categorias = [
  "Alergología",
  "Alta Esp. en Cirugía Articular",
  "Anatomopatología",
  "Cardiólogía",
  "Cirugía de Columna",
  "Cirugía General",
  "Cirugía Pediatrica",
  "Coloproctología",
  "Endocrinología",
  "Endocrinología Pediatrica",
  "Estética y Rehabilitación Oral",
  "Gastroenterología",
  "Geriatría Internista",
  "Ginecología y Obstetricia",
  "Hepatología",
  "Histopatología",
  "Laparoscopia Avanzada",
  "Medicina Interna",
  "Medicina general",
  "Medicina Materno Fetal",
  "Medicina de urgencias",
  "Motilidad Digestiva",
  "Nefrología",
  "Neonatología",
  "Neurología",
  "Odontología",
  "Oftalmología",
  "Oncología",
  "Otorrinolaringología",
  "Ortodoncia",
  "Pediatría",
  "Pediatra Intensivista",
  "Pediatra Alergólogo",
  "Radiología e Imagen",
  "Reemp. art. cadera y rodilla",
  "Traumatología y Ortopedia",
  "Urología Oncológica",
  "Urología"
];

export const dataEspecialistas = [
  {
    id: "med-001",
    imagen: JaimeDiazValdivia,
    especialidad: "Alergología",
    subespecialidad: "Pediatra Alergólogo",
    nombre: "Dr. Jaime Díaz Valdivia",
    DGPE: "5836072",
    CPE: "10508493",
    CPE_01: "13477307",
    telefono: "(311)2119470 ext. 107",
    numero: "3112119470",
    whatsapp: "3117439449", 
    //pdf: archivoDePrueba,
  },
  {
    id: "med-002",
    imagen: example, //AbrahamBernalSandoval,
    especialidad: "Cardiólogía",
    subespecialidad: "Medicina interna",
    nombre: "Dr. Abraham Bernal Sandoval",
    DGPE: "8983841",
    CPE: "13057479",
    CPE_01: "12929549",
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882", 
  },
  {
    id: "med-003",
    imagen: example, //BlancaMendezVizarron,
    especialidad: "Cardiólogía",
    subespecialidad: null,
    nombre: "Dra. Blanca Mendez Bizarron",
    DGPE: "7980419",
    CPE: "10922477",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882", 
  },
  {
    id: "med-004",
    imagen: KristianJavierNavarreteBecerra,
    especialidad: "Cardiólogía",
    subespecialidad: null,
    nombre: "Dr. Kristian Javier Navarrete Becerra",
    DGPE: "7874291",
    CPE: "11650272",
    CPE_01: null,
    telefono: "(311)2119470 ext. 107",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-005",
    imagen: EnriqueIgnacioSolteroMartinez,
    especialidad: "Cardiólogía",
    subespecialidad: "Medicina Interna",
    nombre: "Dr. Enrique Ignacio Soltero Martínez",
    DGPE: "0722248",
    CPE: "3166505",
    CPE_01: "3270301",
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-006",
    imagen: RicardoSahagunSanchez,
    especialidad: "Cardiólogía",
    subespecialidad: null,
    nombre: "Dr. Ricardo Sahagún Sánchez",
    DGPE: "0630107",
    CPE: "3393890",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-007",
    imagen: example, //DaliaVictoriaMendezBizarron,
    especialidad: "Cirugía general",
    subespecialidad: null,
    nombre: "Dra. Dalia Victoria Mendez Bizarron",
    DGPE: "08713359",
    CPE: "11195284",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-008",
    imagen: example, //DavidAlejandroGollazSesteaga,
    especialidad: "Cirugía general",
    subespecialidad: null,
    nombre: "Dr. David Alejandro Gollaz Sesteaga",
    DGPE: "12142652",
    CPE: "14547379",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-009",
    imagen: example, //EdwinOmarFragozaAguillares,
    especialidad: "Cirugía General",
    subespecialidad: "Laparoscopia Avanzada",
    nombre: "Dr. Edwin Omar Fragoza Aguillares",
    DGPE: "6756230",
    CPE: "09290716",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111822183",
  },
  {
    id: "med-010",
    imagen: FranciscoJavierMunizCoronado,
    especialidad: "Cirugía General",
    subespecialidad: "Motilidad Digestiva",
    nombre: "Dr. Francisco Javier Muniz Coronado",
    DGPE: "4454932",
    CPE: "7046221",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3117436919",
  },
  {
    id: "med-011",
    imagen: example, //LauraGuillerminaCalderonParra,
    especialidad: "Cirugía General",
    subespecialidad: null,
    nombre: "Dra. Laura Guillermina Calderon Parra",
    DGPE: "8564089",
    CPE: "11489578",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-012",
    imagen: example, //MiguelCallerosMariscal,
    especialidad: "Cirugía General",
    subespecialidad: null,
    nombre: "Dr. Miguel Calleros Mariscal",
    DGPE: "2965645",
    CPE: "4860278",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-013",
    imagen: example, //AlmaRosaMedinaFong,
    especialidad: "Coloproctología",
    subespecialidad: null,
    nombre: "Dra. Alma Rosa Medina Fong",
    DGPE: "2635399",
    CPE: "5212348",
    CPE_01: "5848289",
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-014",
    imagen: JosselineRodriguez,
    especialidad: "Endocrinología Pediatrica",
    subespecialidad: null,
    nombre: "Dra. Josseline Rodríguez",
    DGPE: "12075686",
    CPE: "13422600",
    CPE_01: "14882389",
    telefono: "(311)2119470 ext. 107",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-015",
    imagen: AlejandroSolano,
    especialidad: "Endocrinología Pediatrica",
    subespecialidad: null,
    nombre: "Dr. Alejandro Solano",
    DGPE: "6900791",
    CPE: "10826485",
    CPE_01: "11126073",
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-016",
    imagen: example, //EfrainMagañaSalas,
    especialidad: "Gastroenterología",
    subespecialidad: null,
    nombre: "Dr. Efraín Magaña Salas",
    DGPE: "2981394",
    CPE: "5052284",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-017",
    imagen: GilbertodeJesusParraTorres,
    especialidad: "Gastroenterología",
    subespecialidad: "Hepatología",
    nombre: "Dr. Gilberto de Jesús Parra Torres",
    DGPE: "6276097",
    CPE: "10031185",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-018",
    imagen: GilbertoMedinaFong,
    especialidad: "Geriatría Internista",
    subespecialidad: null,
    nombre: "Dr. Gilberto Medina Fong",
    DGPE: "3507985",
    CPE: "7352969",
    CPE_01: "6745642",
    telefono: "(311)2119470 ext. 181",
    numero: "3112119470",
    whatsapp: "3112013658",
  },
  {
    id: "med-019",
    imagen: LuisAntonioFloreRuvalcaba,
    especialidad: "Geriatría Internista",
    subespecialidad: null,
    nombre: "Dr. Luis Antonio Flores Ruvalcaba",
    DGPE: "7157341",
    CPE: "9739415",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3315351352",
  },
  {
    id: "med-020",
    imagen: example, //AlfredoEstrellaTejeda,
    especialidad: "Ginecología y obstetricia",
    subespecialidad: null,
    nombre: "Dr. Alfredo Estrella Tejeda",
    DGPE: "09709274",
    CPE: "13310070",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-021",
    imagen: HectorLeonardoTorresSoltero,
    especialidad: "Ginecología y Obstetricia",
    subespecialidad: null,
    nombre: "Dr. Héctor Leonardo Torres Soltero",
    DGPE: "0501921",
    CPE: "3277271",
    CPE_01: null,
    telefono: "(311)2119470 ext. 181",
    numero: "3112119470",
    whatsapp: "3112013658",
  },
  {
    id: "med-022",
    imagen: example, //LizethHaroRangel,
    especialidad: "Ginecología y Obstetricia",
    subespecialidad: null,
    nombre: "Dra. Lizeth Haro Rangel",
    DGPE: "11627634",
    CPE: "14670268",
    CPE_01: "15462709",
    telefono: "(311)2119470 ext. 140",
    numero: "3112119470",
    whatsapp: "3111175290",
  },
  {
    id: "med-023",
    imagen: example, //PerlaNolascoNavarro,
    especialidad: "Ginecología y Obstetricia",
    subespecialidad: null,
    nombre: "Dra. Perla Nolasco Navarro",
    DGPE: "11756827",
    CPE: "14744876",
    CPE_01: null,
    telefono: "(311)2119470 ext. 140",
    numero: "3112119470",
    whatsapp: "3222142243",
  },
  {
    id: "med-024",
    imagen: example, //RamonGonzalezBobadilla,
    especialidad: "Ginecología y Obstetricia",
    subespecialidad: null,
    nombre: "Dr. Ramón González Bobadilla",
    DGPE: "0656299",
    CPE: "6323357",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-025",
    imagen: example, //AuroraCallerosCortes,
    especialidad: "Histopatología",
    subespecialidad: "Anatomopatología",
    nombre: "Dra. Aurora Calleros Cortés",
    DGPE: "2904186",
    CPE: "6097265",
    CPE_01: null,
    telefono: "(311)2119470 ext. 140",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-026",
    imagen: example, //AnaKarenPoncePerez,
    especialidad: "Medicina Interna",
    subespecialidad: null,
    nombre: "Dra. Ana Karen Ponce Pérez",
    DGPE: "8562729",
    CPE: "11589132",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-028",
    imagen: example, //GiovanyFranciscoNoriegaHernandez,
    especialidad: "Medicina Interna",
    subespecialidad: "Oncología",
    nombre: "Dr. Giovany Francisco Noriega Hernández",
    DGPE: "8015912",
    CPE: "13995673",
    CPE_01: "15096920",
    telefono: "(311)2119470 ext. 140",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  // {
  //   id: "med-029",
  //   imagen: example, //JoseAntonioCarrilloSegura,
  //   especialidad: "Medicina Interna",
  //   subespecialidad: null,
  //   nombre: "Dr. José Antonio Carrillo Segura",
  //   DGPE: null,
  //   telefono: "(311)2119470 ext. 128",
  //   numero: "3112119470",
  //   whatsapp: "3111095882",
  // },
  {
    id: "med-030",
    imagen: example, //GreciaAlarconFlores,
    especialidad: "Nefrología",
    subespecialidad: null,
    nombre: "Dra. Grecia Alarcon Flores",
    DGPE: "11481717",
    CPE: "14113064",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-031",
    imagen: example, //EliaJudithCoronaGalvan,
    especialidad: "Nefrología",
    subespecialidad: null,
    nombre: "Dra. Elia Judith Corona Galván",
    DGPE: "2197171",
    CPE: "6673326",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-032",
    imagen: AntonioDuranOrtega,
    especialidad: "Neurocirugía",
    subespecialidad: null,
    nombre: "Dr. Antonio Durán Ortega",
    DGPE: "1763818",
    CPE: "0010798",
    CPE_01: "3270331",
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-033",
    imagen: example, //JoseAlbertoCruzCruz,
    especialidad: "Neurocirugía",
    subespecialidad: null,
    nombre: "Dr. José Alberto Cruz Cruz",
    DGPE: "5746778",
    CPE: "11055456",
    CPE_01: "11988703",
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-034",
    imagen: RicardoSahagunTopete,
    especialidad: "Neurología",
    subespecialidad: null,
    nombre: "Dr. Ricardo Sahagun Topete",
    DGPE: "6591998",
    CPE: "10508480",
    CPE_01: null,
    telefono: "(311)2119470 ext. 107",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-035",
    imagen: example, //EloisaPlattSoberanes,
    especialidad: "Oftalmología",
    subespecialidad: null,
    nombre: "Dra. Eloísa Platt Soberanes",
    DGPE: "4559102",
    CPE: "5314308",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3112563856",
  },
  {
    id: "med-036",
    imagen: example, //RobertoDiazCavazos,
    especialidad: "Oftalmología",
    subespecialidad: null,
    nombre: "Dr. Roberto Diaz Cavazos",
    DGPE: "3629978",
    CPE: "4862438",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3112563856",
  },
  {
    id: "med-037",
    imagen: example, //DenisseIvetteBuenoGonzalez,
    especialidad: "Odontología",
    subespecialidad: "Estética y Rehabilitación Oral",
    nombre: "Dra. Denisse Ivette Bueno González",
    DGPE: "11512533",
    CPE: null,
    CPE_01: null,
    telefono: "311 211 9470 ext. 176",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-038",
    imagen: example, //PeterAliGarciaVelazco,
    especialidad: "Odontología",
    subespecialidad: "Ortodoncia",
    nombre: "Dr. Peter Alí García Velazco",
    DGPE: null,
    CPE: null,
    CPE_01: null,
    telefono: "311 211 9470 ext. 176",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-040",
    imagen: JoseMiguelPlascenciaRamirez,
    especialidad: "Otorrinolaringología",
    subespecialidad: null,
    nombre: "Dr. José Miguel Plascencia Ramírez",
    DGPE: "6850954",
    CPE: "8931464",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-041",
    imagen: example, //RocioYañezZambrano,
    especialidad: "Otorrinolaringología",
    subespecialidad: null,
    nombre: "Dra. Rocío Yáñez Zambrano",
    DGPE: "7251959",
    CPE: "10727583",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-042",
    imagen: MariadelRocioZambranoCarrillo,
    especialidad: "Otorrinolaringología",
    subespecialidad: null,
    nombre: "Dra. María del Rocío Zambrano Carrillo",
    DGPE: "1176192",
    CPE: "0030070",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-043",
    imagen: example, //AnaLiliaRodriguezdelaPeña,
    especialidad: "Pediatría",
    subespecialidad: "Cirugía Pediatrica",
    nombre: "Dra. Ana Lilia Rodríguez de la Peña",
    DGPE: "2651630",
    CPE: "0025061",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-044",
    imagen: example, //ElizabethLopezChavez,
    especialidad: "Pediatría",
    subespecialidad: "Neonatología",
    nombre: "Dra. Elizabeth López Chávez",
    DGPE: "1815649",
    CPE: "0011043",
    CPE_01: "0021284",
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  // {
  //   id: "med-045",
  //   imagen: EvelynSeleneCortesSalvio,
  //   especialidad: "Pediatría",
  //   subespecialidad: "Neonatología",
  //   nombre: "Dra. Evelyn Selene Cortés Salvio",
  //   DGPE: "11540617",
  //   telefono: "(311)2119470 ext. 128",
  //   numero: "3112119470",
  //   whatsapp: "3111095882",
  // },
  {
    id: "med-046",
    imagen: MiguelLiceaPerezPeña,
    especialidad: "Pediatría",
    subespecialidad: "Neonatología",
    nombre: "Dr. Miguel Licea Pérez Peña",
    DGPE: "0666933",
    CPE: "3393810",
    CPE_01: "0026600",
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-047",
    imagen: SilviaRodriguezJimenez,
    especialidad: "Pediatría",
    subespecialidad: null,
    nombre: "Dra. Silvia Rodríguez Jiménez",
    DGPE: "5830980",
    CPE: "11460626",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-048",
    imagen: JoseAlbertoGutierrezMata,
    especialidad: "Radiología e Imagen",
    subespecialidad: null,
    nombre: "Dr. José Alberto Gutiérrez Mata",
    DGPE: "2048188",
    CPE: "0017241",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-049",
    imagen: example, //AlejandroAvalosFlores,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: null,
    nombre: "Dr. Alejandro Ávalos Flores",
    DGPE: "3774683",
    CPE: "6167498",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-050",
    imagen: example, //EliasBenjaminPreciadoTovar,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: null,
    nombre: "Dr. Elias Benjamín Preciado Tovar",
    DGPE: "11762246",
    CPE: "13848324",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-051",
    imagen: example, //JorgeGarciaValencia,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: null,
    nombre: "Dr. Jorge García Valencia",
    DGPE: "4413839",
    CPE: "6745838",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-052",
    imagen: JoseCarlosdelRealMartinez,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: "Alta Esp. en Cirugía Articular",
    nombre: "Dr. José Carlos del Real Martínez",
    DGPE: "8593303",
    CPE: "11280294",
    CPE_01: null,
    telefono: "(311)2119470 ext. 107",
    numero: "3112119470",
    whatsapp: "3112534263",
  },
  {
    id: "med-053",
    imagen: JoseBenitodelRealMartinez,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: "Alta Esp. en Cirugía Articular",
    nombre: "Dr. José Benito del Real Martínez",
    DGPE: "9830302",
    CPE: "12187078",
    CPE_01: null,
    telefono: "(311)2119470 ext. 107",
    numero: "3112119470",
    whatsapp: "3112534263",
  },
  {
    id: "med-054",
    imagen: LuisErnestoHernandezRico,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: null,
    nombre: "Dr. Luis Ernesto Hernández Rico",
    DGPE: "4009430",
    CPE: "5687069",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-055",
    imagen: example, //MarthaTorresVillanueva,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: "Reemp. art. cadera y rodilla",
    nombre: "Dra. Martha Torres Villanueva",
    DGPE: "12094870",
    CPE: "14235358",
    CPE_01: "15675847",
    telefono: "(311)2119470 ext. 140",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-056",
    imagen: example, //LuisRaulMartinezOrtega,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: null,
    nombre: "Dr. Luis Raúl Martínez Ortega",
    DGPE: "7885910",
    CPE: "11187199",
    CPE_01: null,
    telefono: "(311)2119470 ext. 140",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-057",
    imagen: example, //SealtielAlfonsoVilledaGomez,
    especialidad: "Traumatología y Ortopedia",
    subespecialidad: "Cirugía de Columna",
    nombre: "Dr. Sealtiel Alfonso Villeda Gómez",
    DGPE: "7935822",
    CPE: "11783462",
    CPE_01: null,
    telefono: "(311)2119470 ext. 158",
    numero: "3112119470",
    whatsapp: "3111204318",
  },
  {
    id: "med-058",
    imagen: example, //AlicaLizbethMendez,
    especialidad: "Urología",
    subespecialidad: null,
    nombre: "Dra. Alica Lizbeth Mendez Cueto",
    DGPE: "09291676",
    CPE: "12946840",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-059",
    imagen: ChristopherPeñaGeorge,
    especialidad: "Urología Oncológica",
    subespecialidad: null,
    nombre: "Dr. Christopher Peña George",
    DGPE: "3810021",
    CPE: "6525364",
    CPE_01: null,
    telefono: "(311)2119470 ext. 226",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-060",
    imagen: example, //MarianaIsabelAguirreLopez,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dra. Mariana Isabel Aguirre López",
    DGPE: "13898352",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-061",
    imagen: example, //SalimMayrenArelizBriseño,
    especialidad: "Medicina de urgencias",
    subespecialidad: null,
    nombre: "Dra. Salim Mayren Areliz Briseño",
    DGPE: "5424045",
    CPE: "11648928",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-062",
    imagen: example, //IsraelArteagaMondragon,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Israel Arteaga Mondragon",
    DGPE: "4077387",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-064",
    imagen: example, //EduardodeLeonLegaspi,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Eduardo de León Legaspi",
    DGPE: "14794629",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-065",
    imagen: example, //GabrieldelToroAviña,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Gabriel del Toro Aviña",
    DGPE: "11767139",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-066",
    imagen: example, //DominguezCorralIrvingAntonio,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Irving Antonio Dominguez Corral",
    DGPE: "12267638",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-067",
    imagen: example, //IrwinJhamilEspericuetaRamirez,
    especialidad: "Medicina de urgencias",
    subespecialidad: null,
    nombre: "Dr. Irwin Jhamil Espericueta Ramírez",
    DGPE: "10217583",
    CPE: "15140030",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-069",
    imagen: example, //FernandoAlfonsoGarciaSanchez,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Fernando Alfonso García Sánchez",
    DGPE: "12290143",
    CPE: "14276363",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-070",
    imagen: example, //JorgeBaltazarGomezGarcia,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Jorge Baltazar Gómez García",
    DGPE: "12860043",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-071",
    imagen: example, //EdgarEduardoGonzalezIsiordia,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Edgar Eduardo González Isiordia",
    DGPE: "14778067",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-072",
    imagen: example, //UrielLangaricaHernández,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Uriel Langarica Hernández",
    DGPE: "14804249",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-073",
    imagen: example, //BarbaraLizbetLoureiroManjarrez,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dra. Barbara Lizbet Loureiro Manjarrez",
    DGPE: "7980970",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-074",
    imagen: example, //JohansCrosbyMontesHuerta,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Johans Crosby Montes Huerta",
    DGPE: "4534272",
    CPE: "09941241",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-075",
    imagen: example, //JoseLuisRamirezLopez,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. José Luis Ramírez López",
    DGPE: "15248747",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-076",
    imagen: example, //LuisAlbertoRoblesRodriguez,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Luis Alberto Robles Rodríguez",
    DGPE: "14753106",
    CPE: "15031853",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-077",
    imagen: example, //RomeoAlbertoRodriguezMartinez,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Romeo Alberto Rodríguez Martínez",
    DGPE: "5740797",
    CPE: "11907104",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-078",
    imagen: example, //ZoraydaPatriciaTiradoPeralta,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dra. Zorayda Patricia Tirado Peralta",
    DGPE: "8983817",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-079",
    imagen: example, //CelsoValderramaGarcía,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dr. Celso Valderrama García",
    DGPE: "14567817",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-080",
    imagen: example, //OscarJavierVillanuevaEscobar,
    especialidad: "Medicina de urgencias",
    subespecialidad: null,
    nombre: "Dr. Oscar Javier Villanueva Escobar",
    DGPE: "5743302",
    CPE: "12604014",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-081",
    imagen: example,//JoanaBelenZuñigaIbarra,
    especialidad: "Medicina general",
    subespecialidad: null,
    nombre: "Dra. Joana Belén Zuñiga Ibarra",
    DGPE: "13418179",
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-082",
    imagen: example,
    especialidad: "Alergología",
    subespecialidad: null,
    nombre: "Dra. Alicia Mendez Gómez",
    DGPE: "10291707",
    CPE: "14379240",
    CPE_01: null,
    telefono: "(311)2119470 ext. 170",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-083",
    imagen: example,
    especialidad: "Ginecología y obstetricia",
    subespecialidad: "Medicina Materno Fetal",
    nombre: "Dra. Carolina Elizabeth Suárez Vilchis",
    DGPE: "12008318",
    CPE: "14634315",
    CPE_01: null,
    telefono: "(311)2119470 ext. 176",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-083",
    imagen: example,
    especialidad: "Ginecología y obstetricia",
    subespecialidad: null,
    nombre: "Dra. Blanca Guadalupe Vera Luna",
    DGPE: null,
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 176",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-084",
    imagen: example,
    especialidad: "Traumatología",
    subespecialidad: "Traumatología y Ortopedia",
    nombre: "Dr. Humberto García Sánchez",
    DGPE: null,
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 176",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-085",
    imagen: example,
    especialidad: "Traumatología",
    subespecialidad: "Traumatología y Ortopedia",
    nombre: "Dr. César Iván López González",
    DGPE: "12403678",
    CPE: "15096249",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-086",
    imagen: example,
    especialidad: "Traumatología",
    subespecialidad: "Traumatología y Ortopedia",
    nombre: "Dr. José Gabriel Alejandro Durán Ruiz",
    DGPE: "10232051",
    CPE: "15116582",
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-087",
    imagen: example,
    especialidad: "Traumatología",
    subespecialidad: "Traumatología y Ortopedia",
    nombre: "Dr. Juan Manuel Ibarra de la Torre",
    DGPE: "10899558",
    CPE: "15548352",
    CPE_01: null,
    telefono: "(311)2119470 ext. 107",
    numero: "3112119470",
    whatsapp: "3111095882",
  },
  {
    id: "med-088",
    imagen: example,
    especialidad: "Traumatología",
    subespecialidad: "Traumatología y Ortopedia",
    nombre: "Dr. Francisco Emmanuel Reyes Alvez",
    DGPE: null,
    CPE: null,
    CPE_01: null,
    telefono: "(311)2119470 ext. 128",
    numero: "3112119470",
    whatsapp: "4521022560",
  },
];
